import useExperimentStore from '@/stores/experiment'

function request<T>(url: string, options: any, showError = true): Promise<T | undefined> {
  return new Promise((resolve, reject) => {
    // #ifdef H5
    const experimentStore = useExperimentStore()
    const urlSearchParams = new URLSearchParams(location.search)
    if (options.method === 'POST') {
      // 只有从活动进入才有ab实验
      if (urlSearchParams.has('a')) {
        options.data = Object.assign({}, options.data, {
          experimentUserId: uni.getStorageSync('USER_COID'),
          experimentInfo: experimentStore.getTrackExperimentInfo(),
        })
      }
      options.data = Object.assign({}, options.data, {
        coid: uni.getStorageSync('USER_COID'),
      })
    }
    // #endif
    uni.request({
      url: import.meta.env.VITE_API_URL + url,
      ...options,
      success: (res: any) => {
        if (res.data.code !== 200) {
          if (showError) {
            uni.showToast({
              title: res.data.msg || '网络波动，请重试',
              icon: 'none',
            })
          }
          reject(res.data || {
            msg: '网络波动，请重试',
          })
        }
        resolve(res.data.data as T)
        // resolve(responseData<T>(res, showError));
      },
      fail: (err: any) => {
        reject(err)
      },
    })
  })
}

function upload<T>(url: string, options: any, showError = true): Promise<T | undefined> {
  return new Promise((resolve, reject) => {
    uni.uploadFile({
      url: import.meta.env.VITE_API_URL + url,
      ...options,
      success: (res: any) => {
        try {
          res.data = JSON.parse(res.data)
        }
        catch (e) {
          uni.showToast({
            title: '网络波动，请重试',
            icon: 'none',
          })
        }
        if (res.data.code !== 200) {
          if (showError) {
            uni.showToast({
              title: res.data.msg || '网络波动，请重试',
              icon: 'none',
            })
          }
          reject(res.data || {
            msg: '网络波动，请重试',
          })
        }
        resolve(res.data.data as T)
        // resolve(responseData<T>(res, showError));
      },
      fail: (err: any) => {
        reject(err)
      },
    })
  })
}

/**
 * 响应数据过滤
 * @param res 响应数据
 */
function responseData<T>(res: any, showError = true) {
  if (res.data.code !== 200) {
    if (showError) {
      uni.showToast({
        title: res.data.msg || '网络波动，请重试',
        icon: 'none',
      })
    }
    throw new Error(res.data.msg || '网络波动，请重试')
  }
  return res.data.data as T
}

export { request, upload }
